import React from "react";

export default () => {
  return <p id="vrsn">{process.env.REACT_APP_VERSION}</p>;
};
